<mat-toolbar role="header" class="primary-toolbar">
    <div style="display: flex; align-items: center">
        <button
            type="button"
            class="menu-btn"
            mat-icon-button
            (click)="onMenu()"
        >
            <mat-icon class="material-icons">menu</mat-icon>
        </button>
        <div onclick="onMenu()" fxFlex="100px">Hydra V3</div>
    </div>

    @if (showShortcutInput) {
        <div class="search-col">
            <input
                matInput
                (blur)="showShortcutInput = false"
                [(ngModel)]="shortcut"
                (keydown)="DoShortcut($event)"
                class="search-bar"
                placeholder="Shortcut..."
            />
        </div>
    }

    <div>
        <div class="error-container">
            @if (loadingService.error) {
                <div
                    class="error"
                    matTooltip="{{ loadingService.errorMessage }}"
                    matTooltipClass="red-tooltip"
                    matTooltipHideDelay="500"
                >
                    <mat-icon>error</mat-icon>
                </div>
            }
        </div>
        @if (loadingService.isLoading$() | async) {
            <div>
                <!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="default" color="white" type="ball-beat" [fullScreen]="false">
      </ngx-spinner> -->
            </div>
        }
    </div>

    <div class="action-container">
        @if (user(); as user) {
            <button
                matTooltip="Logout"
                type="button"
                (click)="signOut()"
                mat-stroked-button
            >
                <mat-icon class="material-icons">logout</mat-icon>
                {{ user.name }}
            </button>
        }
        <button
            matTooltip="Settings"
            [matMenuTriggerFor]="settings"
            mat-icon-button
        >
            <mat-icon class="material-icons">settings</mat-icon>
        </button>
        <mat-menu #settings="matMenu">
            <button mat-menu-item (click)="openShortCuts()">Shortcuts</button>
            <mat-slide-toggle
                (click)="$event.stopPropagation()"
                [(ngModel)]="darkMode"
                >Dark Mode</mat-slide-toggle
            >
        </mat-menu>
    </div>
</mat-toolbar>
